var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPluginsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.59,15a1.11,1.11,0,0,1-1.08-1v-.13a1.12,1.12,0,0,1,1.09-1.14h1.76V11.09a1.11,1.11,0,0,1,1-1.08h.13a1.13,1.13,0,0,1,1.15,1.09v1.26l7-7a1.94,1.94,0,0,0-.73-.14H17.74a.38.38,0,0,1-.4-.55,3.21,3.21,0,0,0,.4-1.54A3.13,3.13,0,1,0,11.9,4.71c.11.18,0,.51-.42.51H7.3A2.08,2.08,0,0,0,5.22,7.3v3.13c0,.55-.31.55-.48.45A3.13,3.13,0,1,0,3.13,16.7a3.06,3.06,0,0,0,1.59-.44c.18-.1.5-.1.5.44v5.21a1.94,1.94,0,0,0,.14.73L13,15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.3,24H21.91A2.08,2.08,0,0,0,24,21.91V17.74c0-.45-.21-.61-.5-.57a3.29,3.29,0,0,1-.54,0A3.13,3.13,0,0,1,23,11a2.5,2.5,0,0,1,.55,0c.28,0,.49-.1.49-.58V7.3a2.07,2.07,0,0,0-1.36-1.94l-7,7v.36h1.76a1.1,1.1,0,0,1,1.08,1v.12A1.12,1.12,0,0,1,17.41,15H15.65v1.91a1.11,1.11,0,0,1-1,1.08H14.5a1.13,1.13,0,0,1-1.15-1.09V15H13L5.36,22.64A2.07,2.07,0,0,0,7.3,24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluginsLight);
export default __webpack_public_path__ + "static/media/plugins-light.8e48745a1fbd2e27cd21220b67a7e194.svg";
export { ForwardRef as ReactComponent };